export default __webpack_public_path__ + "static/sterylnosc_mini-ba938fe9fc1508cb5e63bfcbf0fe8a7b.jpg";